module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_c('nav', {
    staticClass: "sidebar-nav"
  }, [_c('ul', {
    staticClass: "nav"
  }, [(_vm.$store.state.organization.id) ? _c('li', {
    staticClass: "nav-title"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_c('span', [_c('img', {
    staticClass: "client-logo",
    attrs: {
      "src": _vm.logo
    }
  })]), _vm._v(" "), _vm._l((_vm.$store.state.linked_organizations), function(org, index) {
    return _c('div', {
      staticClass: "dropdown-content"
    }, [_c('p', [_c('a', {
      attrs: {
        "href": '/dashboard/' + org.id
      }
    }, [_c('img', {
      staticClass: "client-logo",
      attrs: {
        "src": org.logo
      }
    })])])])
  })], 2)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sections), function(sec, index) {
    return _c('div', [_c('div', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: (sec['label']),
        expression: "sec['label']"
      }]
    }, [_c('router-link', {
      staticClass: "btn btn-primary w-100 h-100 mt-2",
      attrs: {
        "to": '/' + sec['path'] + '/' + sec['org_id']
      }
    }, [_c('i', {
      class: 'fas ' + sec['icon']
    }), _vm._v("  " + _vm._s(sec['label']))])], 1)])
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f40f8220"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 527
// module chunks = 1